import React from 'react';
import { useSelector } from 'react-redux';
import { FormControlLabel } from '@mui/material';
import CheckboxMUI from '@mui/material/Checkbox';

export const Checkbox = ({
  variant = 'outlined',
  selections,
  label,
  large,
  value,
  size,
  onChange,
  onBlur,
  error,
  help,
  required,
  field,
  ...props
}) => {
  const businessPreference = useSelector((state) => state.core.businessData);
  return (
    <div>
      <FormControlLabel
        required={required}
        error={props.error}
        helperText={help || error}
        className="form-control-single"
        control={
          <CheckboxMUI
            checked={value || false}
            onChange={(event) => onChange && onChange(event, 'boolean')}
            onClick={(event) => onBlur && onBlur(event, 'boolean')}
            sx={{
              '&.MuiCheckbox-root': {
                color: businessPreference?.mainColor || '#000',
              },
              '&.MuiCheckbox-checked': {
                color: businessPreference?.mainColor || '#000',
              },
            }}
          />
        }
        label={label}
        sx={{
          fontSize: size === 'small' ? '11px' : '13px',
        }}
      />
    </div>
  );
};

export default Checkbox;
